import axiosInstance from "./api";

export const getCommandCenterData = async (params) => {
  return axiosInstance.get("dashboard/command-center", {
    params,
  });
};

export const getFeedbackByDomainData = async (params) => {
  return axiosInstance.get("feedback-by-domain/getElms", { params });
};

export const getMiniappUsersDashboardData = async () => {
  return axiosInstance.get("miniapp-users");
};

export const getMiniappUsersByTdp = async (params) => {
  return axiosInstance.get("miniapp-users/by-tdp", { params });
};

export const getMiniappUsersByOfficer = async (params) => {
  return axiosInstance.get("miniapp-users/by-officer", { params });
};

const exportMiniappUsersReport = async (path, params = {}) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== ""),
  ).toString();
  const url = `${baseUrl}/miniapp-users/${path}${query ? `?${query}` : ""}`;

  const token = axiosInstance._getAccessToken?.();
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(url, { headers, credentials: "include" });
  if (!response.ok) {
    throw new Error(
      `Export thất bại: ${response.status} ${response.statusText}`,
    );
  }

  return response.blob();
};

export const exportMiniappUsersByTdpExcel = async (params = {}) => {
  return exportMiniappUsersReport("by-tdp/exportExcel", params);
};

export const exportMiniappUsersByOfficerExcel = async (params = {}) => {
  return exportMiniappUsersReport("by-officer/exportExcel", params);
};

export const getNewsAnalyticsDashboardData = async () => {
  return axiosInstance.get("news-analytics");
};

export const getSidebarCounts = async () => {
  return axiosInstance.get("dashboard/sidebar-counts");
};
